// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aptitudes{
    padding: 24px 36px;
}

.aptitudes .baloa-names{
    color: var(--primary-very-dark-color)
}

.aptitudes__list {
    padding: var(--space) 0;
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;
}

.aptitudes__list .baloa-table{
    color: var(--basic-gray-color);
    padding: 40px 0;
    margin: 0 auto;
    text-align: center;
}

.aptitudes__list__aptitude {
    border: 2px solid var(--new-green-color);
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    column-gap: 8px;
    justify-content: space-between;
    align-items: center;
    padding: var(--space-half) var(--space);
}
.aptitudes__list__aptitude.selected {
    background-color: #EAF7F0;
}
.aptitudes__list__aptitude:hover {
    cursor: pointer;
    background-color: #EAF7F0;
}
.aptitudes__list__aptitude:active {
    background-color: #EAF7F0;;
}

.aptitudes__list__aptitude.baloa-names{
    color: var(--primary-dark-color);
}

.aptitudes__list__aptitude .hubicon-clear_option, 
.aptitudes__list__aptitude .hubicon-add_option{
    font-size: 22px;
    color: var(--primary-dark-color);
}

.aptitudes__list__aptitude img {
    width: var(--space);
    height: var(--space);
}
.aptitudes__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid var(--new-gray-background-color);
    padding: 16px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .aptitudes_modal-container{
        overflow: hidden;
    }

    .aptitudes_modal-container .modal2__container{
        margin: 0;
        border-radius: 0;
        height: 100%;
        max-height: 100%;
        width: 100%;
        overflow: hidden;
    }

    .aptitudes {
        height: 100vh;
        padding: 16px 0;
    }

    .aptitudes .baloa-names{
        margin-left: 16px;
    }

    .button.aptitudes__actions__submit{
        width: 100%;
    }

    .aptitudes__list__aptitude{
        border: 1px solid var(--new-green-color);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-aptitudes-modal/ProfileAptitudesModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,uCAAuC;AAC3C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,sDAAsD;IACtD,aAAa;AACjB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAChB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,wCAAwC;IAC5C;AACJ","sourcesContent":[".aptitudes{\n    padding: 24px 36px;\n}\n\n.aptitudes .baloa-names{\n    color: var(--primary-very-dark-color)\n}\n\n.aptitudes__list {\n    padding: var(--space) 0;\n    display: flex;\n    flex-wrap: wrap;\n    row-gap: 10px;\n    column-gap: 10px;\n}\n\n.aptitudes__list .baloa-table{\n    color: var(--basic-gray-color);\n    padding: 40px 0;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.aptitudes__list__aptitude {\n    border: 2px solid var(--new-green-color);\n    border-radius: 8px;\n    box-sizing: border-box;\n    display: flex;\n    column-gap: 8px;\n    justify-content: space-between;\n    align-items: center;\n    padding: var(--space-half) var(--space);\n}\n.aptitudes__list__aptitude.selected {\n    background-color: #EAF7F0;\n}\n.aptitudes__list__aptitude:hover {\n    cursor: pointer;\n    background-color: #EAF7F0;\n}\n.aptitudes__list__aptitude:active {\n    background-color: #EAF7F0;;\n}\n\n.aptitudes__list__aptitude.baloa-names{\n    color: var(--primary-dark-color);\n}\n\n.aptitudes__list__aptitude .hubicon-clear_option, \n.aptitudes__list__aptitude .hubicon-add_option{\n    font-size: 22px;\n    color: var(--primary-dark-color);\n}\n\n.aptitudes__list__aptitude img {\n    width: var(--space);\n    height: var(--space);\n}\n.aptitudes__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 16px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .aptitudes_modal-container{\n        overflow: hidden;\n    }\n\n    .aptitudes_modal-container .modal2__container{\n        margin: 0;\n        border-radius: 0;\n        height: 100%;\n        max-height: 100%;\n        width: 100%;\n        overflow: hidden;\n    }\n\n    .aptitudes {\n        height: 100vh;\n        padding: 16px 0;\n    }\n\n    .aptitudes .baloa-names{\n        margin-left: 16px;\n    }\n\n    .button.aptitudes__actions__submit{\n        width: 100%;\n    }\n\n    .aptitudes__list__aptitude{\n        border: 1px solid var(--new-green-color);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
